import moment from 'moment';
import {SEPARATOR} from "constants/AppProps";

export const convertTreeToArray = (treeNode, id = "accountId") => {
    let stack = [], array = [], hashMap = {};
    stack.push(treeNode);

    while (stack.length !== 0) {
        let node = stack.pop();
        if (!node) break;
        if (node.children == null) {
            visitNode(node, hashMap, array, id);
        } else {
            visitNode(node, hashMap, array, id);
            for (let i = node.children.length - 1; i >= 0; i--) {
                stack.push(node.children[i]);
            }
        }
    }
    return array;
};

function visitNode(node, hashMap, array, id) {
    if (node[id] !== "null" && !hashMap[node[id]]) {
        hashMap[node[id]] = true;
        array.push(node);
    }
}


//return true if object ={};
export const checkEmptyObject = (object) => {
    return (Object.keys(object).length === 0 && object.constructor === Object);
};

//return true if object is undefined || null || ""
export const stringNullOrEmpty = (string) => {
    if (string === undefined || string === null || string === "") return true
    return false
};

// return date or null
export const stringToDate = (input, format) => {
    if (stringNullOrEmpty(input)) {
        return null;
    }
    return moment(input, format);
};


export const addThousandSeparator = (inputValue, thousandSeparator = SEPARATOR.THOUSAND_SEPARATOR, decimalSeparator = SEPARATOR.DECIMAL_SEPARATOR) => {
    inputValue += '';
    inputValue = inputValue.split(decimalSeparator);

    if (inputValue[1]) {
        inputValue[1] = decimalSeparator + inputValue[1];
    }

    if (inputValue[0].length > 3) {
        inputValue[0] = inputValue[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousandSeparator);
    }
    return inputValue.join('');
};